<template>
  <div>
    <div class="contain">
      <div class="ipt-box header-box1" :class="{error: (openType == 3 && derivative.derivative.t0.value == 1) || (account_status == 11 && hkStatus == 7 && derivative.derivative.t0.value == 1)}">
        <div class="ipt-main" @click="derivativePicker = true">
          <div class="val-box" >
            <span class="label">{{ $t('suitabilitySurvey.derivatives') }}</span>
            <span class="val" v-if="getDerivativeText(1,1)">{{ getDerivativeText(1,1) }}</span>
          </div>
          <span class="icon-arrow"></span>
        </div>
        <p class="error show" v-if="(openType == 3 && derivative.derivative.t0.value == 1) || (account_status == 11 && hkStatus == 7 && derivative.derivative.t0.value == 1)"> {{ $t('deTopic.derivative.t3') }}</p>
      </div>
      <van-popup v-model="derivativePicker" position="bottom" class="picker-ui">
        <van-picker
          :columns="getInit(1)"
          show-toolbar
          :default-index="getDerivativeText(1,2)"
          @cancel="derivativePicker = false"
          @confirm="onDerivativeConfirm"
        />
      </van-popup>

    <!--  了解    -->
    <div class="derivative-know-box" v-if="derivative.derivative.t0.value == 0">
      <div class="konwtitle">
        {{ $t('investmentExperience.lang0')}}
      </div>
      <div class="check-dom" v-for="(item, index) in $t('suitabilitySurvey.derivative.t0.actions')" :key="`${item.type}-${index}`">
        <!-- 单选 -->
        <template v-if="item.type == 'check'">
          <van-checkbox class="itemChoices" v-model="derivative.derivative.t0.children[item.index]" shape="square">
            <template #icon="props">
              <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
            </template>
            {{ item.title }}
          </van-checkbox>
        </template>
      </div>
    </div>

<!--  公共题目    -->
      <div class="ipt-box header-box1">
        <div class="ipt-main" @click="cusTomPicker = true">
          <div class="val-box" >
            <span class="label">{{ $t('investmentExperience.lang4')}}</span>
            <span class="val" v-if="getDerivativeText(3,1)">{{ getDerivativeText(3,1) }}</span>
          </div>
          <span class="icon-arrow"></span>
        </div>
      </div>
      <div class="tip-box" v-if="derivative.information.t0.value == 0">
        <div class="ipt-box" :class="{'focus':inputFocusId == 2,error: errorStatus && !derivative.information.t0.children.t0}">
          <div class="ipt-main">
            <div class="val-box">
              <span class="label" v-if="derivative.information.t0.children.t0">{{ $t('investmentExperience.lang10') }}</span>
              <van-field
                class="val"
                v-model="derivative.information.t0.children.t0"
                :placeholder="$t('investmentExperience.lang10')"
                @blur="handError(derivative.information.t0.children.t0)"
                @focus="inputFocus(2)"
              ></van-field>
            </div>
          </div>
          <p class="error" v-if="!derivative.information.t0.children.t0 && errorStatus">{{ $t('investmentExperience.lang10') }}</p>
        </div>
      </div>
      <van-popup v-model="cusTomPicker" position="bottom" class="picker-ui">
        <van-picker
          :columns="getInit(3)"
          show-toolbar
          :default-index="getDerivativeText(3,2)"
          @cancel="cusTomPicker = false"
          @confirm="onCusTomConfirm"
        />
      </van-popup>
      <div class="ipt-box header-box1" :class="{error: errorStatus && derivative.information.t1.value == 1}">
        <div class="ipt-main" @click="cusTomTwoPicker = true">
          <div class="val-box" >
            <span class="label">{{ $t('investmentExperience.lang5')}}</span
            >
            <span class="val" v-if="getDerivativeText(4,1)">{{ getDerivativeText(4,1) }}</span>
          </div>
          <span class="icon-arrow"></span>
        </div>
      </div>
      <div class="error-tip" v-if="derivative.information.t1.value == 1">{{ $t('investmentExperience.lang11')}}</div>
      <van-popup v-model="cusTomTwoPicker" position="bottom" class="picker-ui">
        <van-picker
          :columns="getInit(4)"
          show-toolbar
          :default-index="getDerivativeText(4,2)"
          @cancel="cusTomTwoPicker = false"
          @confirm="onCusTomTwoConfirm"
        />
      </van-popup>

<!--      add start-->
<!--      <div class="ipt-box header-box1" >-->
<!--        <div class="ipt-main" @click="cusTomTwoPicker2 = true">-->
<!--          <div class="val-box" >-->
<!--            <span class="label">{{ $t('investmentExperience.lang12')}}</span-->
<!--            >-->
<!--            <span class="val" v-if="getDerivativeText(5,1)">{{ getDerivativeText(5,1) }}</span>-->
<!--          </div>-->
<!--          <span class="icon-arrow"></span>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="error-tip" v-if="derivative.information.t4.value == 0">{{ $t('investmentExperience.lang11')}}</div>-->
<!--      <van-popup v-model="cusTomTwoPicker2" position="bottom" class="picker-ui">-->
<!--        <van-picker-->
<!--          :columns="getInit(5)"-->
<!--          show-toolbar-->
<!--          :default-index="getDerivativeText(5,2)"-->
<!--          @cancel="cusTomTwoPicker2 = false"-->
<!--          @confirm="onCusTomTwoConfirm2"-->
<!--        />-->
<!--      </van-popup>-->
<!--      <div class="tip-box" v-if="derivative.information.t4.value == 1">-->
<!--        <div class="ipt-box" :class="{'focus':inputFocusId == 6,error: errorStatus && !derivative.information.t4.children.t0}">-->
<!--          <div class="ipt-main">-->
<!--            <div class="val-box">-->
<!--              <span class="label" v-if="derivative.information.t4.children.t0">{{ $t('investmentExperience.lang13') }}</span>-->
<!--              <van-field-->
<!--                class="val"-->
<!--                v-model="derivative.information.t4.children.t0"-->
<!--                :placeholder="$t('investmentExperience.lang13')"-->
<!--                @blur="handError(derivative.information.t0.children.t0)"-->
<!--                @focus="inputFocus(6)"-->
<!--              ></van-field>-->
<!--            </div>-->
<!--          </div>-->
<!--          <p class="error" v-if="!derivative.information.t4.children.t0 && errorStatus">{{ $t('investmentExperience.lang13') }}</p>-->
<!--        </div>-->
<!--        <div class="ipt-box" :class="{'focus':inputFocusId == 7,error: errorStatus && !derivative.information.t4.children.t1}">-->
<!--          <div class="ipt-main">-->
<!--            <div class="val-box">-->
<!--              <span class="label" v-if="derivative.information.t4.children.t1">{{ $t('investmentExperience.lang14') }}</span>-->
<!--              <van-field-->
<!--                class="val"-->
<!--                v-model="derivative.information.t4.children.t1"-->
<!--                :placeholder="$t('investmentExperience.lang14')"-->
<!--                @blur="handError(derivative.information.t4.children.t1)"-->
<!--                @focus="inputFocus(7)"-->
<!--              ></van-field>-->
<!--            </div>-->
<!--          </div>-->
<!--          <p class="error" v-if="!derivative.information.t4.children.t1 && errorStatus">{{ $t('investmentExperience.lang14') }}</p>-->
<!--        </div>-->
<!--      </div>-->
<!--      add end-->


      <div class="ipt-box header-box1" :class="{'focus':inputFocusId == 3,error: errorStatus && !derivative.information.t2.value,'blur':inputBlurId == 1}" v-if="showInformation">
        <div class="ipt-main">
          <div class="val-box">
            <span class="label" v-if="derivative.information.t2.value">{{ $t('investmentExperience.lang6') }}</span>
            <van-field
              class="val"
              v-model="derivative.information.t2.value"
              :placeholder="$t('investmentExperience.lang6')"
              @blur="handError(derivative.information.t2.value)"
              @focus="inputFocus(3)"
            ></van-field>
          </div>
        </div>
        <p class="error" v-if="!derivative.information.t2.value && errorStatus">{{ $t('investmentExperience.lang6') }}</p>
      </div>
      <div class="bottom-box" v-if="derivative.derivative.t0.value == 0"></div>

    </div>
    <nav-buttons @on-next="handRecommend"
                 :disabled="getNextDisabled"
                 :showPrev="account_status != 11"
                 :nextText="account_status == 11 ? $t('investmentExperience.lang7') : $t('investmentExperience.lang8')"></nav-buttons>
  </div>
</template>

<script>
import { Checkbox, CheckboxGroup, Field as VanField, Icon, Picker, Popup, Radio, RadioGroup, Toast,Uploader } from "vant";
import investIcon from "@/assets/images/id-card-upload-address.png";
import navButtons from "../components/navButtons.vue";
import Progress from "../components/Progress.vue";
import lrz from "lrz";
import { getBrowser } from "@/utils/browser";
import { closeWebView, setStatementDetailInfo } from "@/utils/hybirdMethods";
import RadioNone from '@/assets/images/open-account/radio.png'
import RadioCheck from '@/assets/images/open-account/radio_check.png'
import CheckNone from '@/assets/images/open-account/check_none.png'
import Checkd from '@/assets/images/open-account/check.png'
import addImg from '@/assets/images/id-card-upload-add.png'
import addDarkImg from '@/assets/images/id-card-upload-add-dark.png'

export default {
  components: {
    VanField,
    Icon,
    VanPopup: Popup,
    VanPicker: Picker,
    VanCheckboxGroup:CheckboxGroup,
    VanCheckbox:Checkbox,
    VanRadioGroup: RadioGroup,
    VanRadio: Radio,
    VanUploader:Uploader,
    Progress,
    navButtons
  },
  data(){
    return {
      RadioNone,
      RadioCheck,
      CheckNone,
      Checkd,
      investIcon,
      addImg,
      addDarkImg,
      derivativePicker:false,
      derivative: {
        derivative:{
          t0: {
            value: 0,
            children: {
              t0: [4],
              t1: ['2'],
              t2: '0',
              t3:[]
            }
          },
          relevant_vouchers:[]
        },
        information:{
          t0:{value:'1',children:{t0:''}},
          t1:{value:'0'},
          t2:{value:''},
          t4: {
            value: '',
            children: {
              t0: "",
              t1: ""
            }
          }
        }
      },
      radioList:this.$t('investmentExperience.lang9'),
      fileList:[],
      fileUrlList:[],
      account_status:'',
      faile_open_info_record_id:'',
      hkStatus:1,
      inputFocusId:null,
      cusTomPicker:false,
      errorStatus:false,
      cusTomTwoPicker:false,
      cusTomTwoPicker2: false,
      isShow:true,
      hbStatus:1,
      server_id:'',
      openType: '', // 加开类型
      pageData: ''  // 页面数据
    }
  },
  created() {
    this.openType = this.$route.query.openType;
    this.getInit()
    this.handDetail()
  },
  mounted() {
    if(this.openType){
      if(getBrowser().isApp){
        setStatementDetailInfo({
          headerTitle: this.$t('openInstitutionServices.g000027')
        });
      }else{
        document.title = this.$t('openInstitutionServices.g000027')
      }
    }
  },
  computed: {
    // q期货 + 期货  申请原因
    showInformation(){
      return this.openType == 3 && this.pageData.is_activity_hk == 1;
    },
    bgColor() {
      return this.$store.getters["common/bgColor"];
    },
    getNextDisabled(){
      let btnDisabled = false
      const informationT1 = this.derivative.information.t1.value
      const childernT0L = this.derivative.derivative.t0.children.t0.length
      const childernT1L = this.derivative.derivative.t0.children.t1.length
      const childernT2 = this.derivative.derivative.t0.children.t2
      const informationT0 = this.derivative.information.t0.value
      const informationT0Ct0 = this.derivative.information.t0.children.t0
      const informationT2 = this.derivative.information.t2.value
      const informationT4 = this.derivative.information.t4.value
      const informationT4_0 = this.derivative.information.t4.children.t0
      const informationT4_1 = this.derivative.information.t4.children.t1
      if(this.derivative.derivative.t0.value == 0){
        if(
          childernT0L + childernT1L <= 0
          || (!childernT2 && this.showInformation )
          || (!informationT0 && !informationT0Ct0)
          || informationT1 == 1
        ){
          btnDisabled = true

          if(informationT0 == 1 && !informationT0Ct0 ){
            btnDisabled = false
          }
          if(informationT0 == 0 && informationT0Ct0 ){
            btnDisabled = false
          }
        }
        if(this.showInformation && !informationT2){
          btnDisabled = true
        }
      }else{
        if(this.server_id == 3 || this.hkStatus == 7){
          btnDisabled = true
        }
      }
      if(this.derivative.derivative.t0.value == 1 && this.openType == 3){
        btnDisabled = true
      }
      // const hk_status = [1,7]
      // if(!hk_status.includes(this.hkStatus)){
      //   
      //   btnDisabled = true
      // }
      if(this.server_id == 6){
        btnDisabled = false
      }
      if((!informationT0 || informationT0 == '0') && !informationT0Ct0){
        btnDisabled = true
      }
      if(informationT1 == 1){
        btnDisabled = true
      }
      if(this.derivative.derivative.t0.value != 1){
      //   1题有答案 2题有答案 3题答案为是  一个成立 即可
        const t0A = this.derivative.derivative.t0.children.t0;
        const t1A = this.derivative.derivative.t0.children.t1;
        const t2A = this.derivative.derivative.t0.children.t2;
        if(!t0A && !t1A && !t2A){
          
          btnDisabled = true;
        }
      }
      // if(informationT4 == '1'){
      //   btnDisabled = !informationT4_0 || !informationT4_1;
      // }
      // if(!informationT4){
      //   btnDisabled = true;
      // }
      return btnDisabled
    }
  },
  methods:{
    // 初始化数组
    getInit(e){
      const key = {
        1:this.$t("suitabilitySurvey.derivative.t0.options"),
        2:this.$t("suitabilitySurvey.derivative.t0.actions"),
        3:this.$t("investmentExperience.lang9"),
        4:this.$t("investmentExperience.lang9"),
        5:this.$t("investmentExperience.lang9"),
      }
      return key[e]
    },
    inputFocus(id){
      this.inputFocusId = id
      const anchor = this.$refs.myAnchor;
      if (anchor) {
        anchor.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动
      }
    },

    handDetail(){
      this.$apis.accountSituationV2().then(res => {
        this.pageData = res;
        const { config_data } = res?.process_info?.["investment_experience"] || {};
        const { extra_open_info_hk,extra_open_info_hb } = res
        this.hkStatus = extra_open_info_hk?.status
        this.hbStatus = extra_open_info_hb?.status
        const serveForm = res?.process_info?.["open_server"]?.config_data || '{}'
        this.server_id = JSON.parse(serveForm).server_id
        if(extra_open_info_hk?.status == 1){
          if(JSON.parse(serveForm).server_id == 6){
            this.isShow = false
          }
        }
        if(extra_open_info_hb?.status == 1 || extra_open_info_hk?.status == 1){
          if(JSON.parse(serveForm).server_id == 3){
            this.isShow = false
          }
        }

        this.account_status = res?.account_status
        this.faile_open_info_record_id = res?.faile_open_info_record_id

        if (config_data) {
          const form = JSON.parse(config_data).cognition_derivatives;
          
          this.derivative = form
          this.fileList = []
          form.derivative.relevant_vouchers.forEach(item =>{
            this.fileList.push({url:item})
          })
          this.getDerivativeText()
        }
        // 非加开不通过回显首开适当性调查的答案
        if(this.account_status != 11 && !config_data){
          const { t0 } = res?.get_open_account_info?.info_extend_many[0]?.examine_list?.derivative || {}
          
          this.derivative.derivative.t0.value = t0.value
          this.derivative.derivative.t0.children.t1 = t0.children.t1
          this.derivative.derivative.t0.children.t0 = t0.children.t0
          this.derivative.derivative.t0.children.t2 = t0.children.t2
        }
      });
    },
    onDerivativeConfirm(e){
      this.derivative.derivative.t0.value = e.value
      this.derivativePicker = false
    },
    onCusTomConfirm(e){
      this.derivative.information.t0.value = e.value
      this.cusTomPicker = false
      this.derivative.information.t0.children.t0 = '';
    },
    onCusTomTwoConfirm(e){
      this.derivative.information.t1.value = e.value
      this.errorStatus = false
      if(e.value == 1){
        this.errorStatus = true
      }
      this.cusTomTwoPicker = false
    },
    onCusTomTwoConfirm2(e){
      this.derivative.information.t4.value = e.value
      this.cusTomTwoPicker2 = false
    },



    getDerivativeText(type,i){
      const valueList = this.getInit(type)
      if (valueList) {
        if (i == 1) {
          if (type == 1 && this.derivative.derivative.t0.value > -1) {
            return valueList.find(item => item.value == this.derivative.derivative.t0.value).text;
          }
          if(type == 3 && this.derivative.information.t0.value > -1){
            return valueList.find(item => item.value == this.derivative.information.t0.value).text;
          }
          if(type == 4 && this.derivative.information.t1.value > -1){
            return valueList.find(item => item.value == this.derivative.information.t1.value).text;
          }
          if(type == 5 && this.derivative.information.t4.value > -1){
            return valueList.find(item => item.value == this.derivative.information.t4.value).text;
          }
        } else {
          if (type == 1 && this.derivative.derivative.t0.value > -1) {
            return valueList.findIndex(item => item.value == this.derivative.derivative.t0.value);
          }
          if(type == 3 && this.derivative.information.t0.value > -1){
            return valueList.findIndex(item => item.value == this.derivative.information.t0.value);
          }
          if(type == 4 && this.derivative.information.t1.value > -1){
            return valueList.findIndex(item => item.value == this.derivative.information.t1.value);
          }
          if(type == 5 && this.derivative.information.t4.value > -1){
            return valueList.findIndex(item => item.value == this.derivative.information.t4.value);
          }
        }
      }
    },

    handError(e){
      this.errorStatus = false
      if(!e){
        this.errorStatus = true
      }
      this.inputFocusId = null
    },

    async afterRead(file) {
      try {
        file = await lrz(file.file, {
          quality: 0.7
        });
        // eslint-disable-next-line no-empty
      } catch (e) {}
      const params = new FormData();
      params.append("file", file.file);
      params.append("put_dir", 'gygjqh_id_card');
      const upLoading = Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      this.$apis
        .uploadFile(params)
        .then(res => {
          this.fileUrlList.push(res.content);
          this.derivative.derivative.relevant_vouchers.push(res.url)
          this.derivative.derivative.t0.children.t3 = this.fileUrlList
          this.getImg()
        })
        .finally(() => {
          upLoading.clear()
        });
    },
    delImg(file) {
      for (let i = 0, len = this.fileList.length; i < len; i++) {
        if (this.fileList[i].content === file.content) {
          this.fileUrlList.splice(i, 1);
          this.fileList.splice(i, 1);
          this.derivative.derivative.relevant_vouchers.splice(i,1)
          this.derivative.derivative.t0.children.t3.splice(i,1)
          this.getImg()
        }
      }
      // this.getImg();
    },
    // 初始化数据
    getFormResult(){
      this.derivative = {
        derivative:{
          t0: {
            value: String(this.derivative.derivative.t0.value),
            children: {
              t0: this.derivative.derivative.t0.children.t0,
              t1: this.derivative.derivative.t0.children.t1,
              t2: this.derivative.derivative.t0.children.t2,
              t3: this.derivative.derivative.t0.children.t3
            }
          },
          relevant_vouchers:this.derivative.derivative.relevant_vouchers
        },
        information:{
          t0:{value: String(this.derivative.information.t0.value),children: {t0: this.derivative.information.t0.children.t0}},
          t1:{value: String(this.derivative.information.t1.value)},
          t2:{value: this.derivative.information.t2.value},
          t4: this.derivative.information.t4
        }
      }
    },

    // 初始调用
    async getImg(){
      await this.getFormResult();
      const params = {
        process_id: 4,
        step_code: 'investment_experience',
        step_order: 3,
        config_data: {
          cognition_derivatives:{
            ...this.derivative
          }
        }
      }
      this.$apis.supplementSaveApi(params)
      this.handDetail()
    },

    async handRecommend(){
      if(this.getNextDisabled){
        this.errorStatus = true
        return
      }
      await this.getFormResult()
      const params = {
        process_id: 4,
        step_code: 'investment_experience',
        step_order: 3,
        config_data: {
          cognition_derivatives:{
            ...this.derivative
          }
        }
      }
      const toastLoading = Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      this.$apis.supplementSaveApi(params).then(res => {
        if (res) {
          // const process_id = this.pageData?.process_info?.open_server?.process_id;
          if(this.account_status == 11){
            this.$apis.saveAccountAccountSecondSaveApi({open_info_record_id:this.faile_open_info_record_id}).then(res =>{
              if(res){
                const browser = getBrowser()
                const isAPP = browser.isApp;
                if(isAPP){
                  toastLoading.clear();
                  closeWebView()
                }else{
                  this.$router.push({
                    path:'/open-account/home'
                  }).finally(() =>{
                    toastLoading.clear();
                  })
                }
              }
            })
          }else{
            this.$router.push({
              path:'/open-account/riskDisclosure',
              query: {
                ...this.$route.query,
              }
            }).finally(() =>{
              toastLoading.clear();
            })
          }
        }
      })
    },
   // 二次修改

  }
};
</script>

<style scoped lang="less">
.contain {
  min-height: 100vh;
  .header-box {
    width: 85%;
    margin: 0 auto;
    min-height: 132px;
    border: 1px solid #D6D5D6;
    border-radius: 8px;
    padding-left: 32px;
    display: flex;
    .left-box{
      .title {
        color: #747377;
        font-size: 24px;
        font-weight: 400;
        margin-top: 20px;
      }
      .select{
        margin-top: 16px;
        color: #17161C;
        font-weight: 500;
        font-size: 32px;
      }
    }
    .right-box{
      flex: 1;
      text-align: right;
      padding-right: 32px;
      padding-top: 50px;
    }
  }
  .derivatives-trading {
    display: flex;
    flex-direction: column;
    width: 90%;
    margin: 20px auto;
    .check-dom{
      margin-bottom: 10px;
    }
  }
  .upload-content{
    width: 156px;
    height: 156px;
    border: 2px dashed rgba(23,22,28,0.45);
    border-radius: 8px;
    text-align: center;
    line-height: 196px;
    margin-left: 30px;
    margin-top: 15px;
    .icon-box{
      .add{
        width: 64px;
        height: 64px;
      }
    }
    .show-img{
      width: 156px;
      height: 156px;
    }
  }
}

.derivativeKnow {
  border: 1px dashed #D6D5D6;
  border-radius: 10px;
  margin-top: 20px;
  width: 84%;
  padding: 20px;
  margin-left: 40px;
  .konwtitle {
    color: #FF9900;
    font-size: 24px;
  }

  .check-dom {
    margin-top: 20px;

    .dom-title {
      font-size: 28px;
    }

    .dom-chek {
      margin-top: 10px;
      padding-bottom: 10px;
    }
  }
}
.derivativeKnow1 {
  margin-top: 20px;
  padding-left: 40px;
  padding-right: 40px;
  .konwtitle {
    color: #FF9900;
    font-size: 24px;
  }

  .check-dom {
    margin-top: 10px;
    .dom-title {
      font-size: 28px;
    }

    .dom-chek {
      margin-top: 10px;
      padding-bottom: 10px;
    }
  }
}

.email-box {
  border-radius: 8px;
  border: 1px solid rgba(23, 22, 28, 0.45);
  margin-top: 10px;
  height: 100px;

  .email-input {
    height: 50px;
    margin-top: 5px;
    width: 90%;
    margin-left: 20px;
  }
}
/deep/ .van-uploader__preview-image{
  width: 156px;
  height: 156px;
  border: 2px dashed rgba(23,22,28,0.45);
  border-radius: 8px;
  text-align: center;
  line-height: 196px;
  margin-left: 30px;
  margin-top: 15px;
}

.black-theme{
   .header-box{
     background: #14151D;
     border: 1px solid rgba(255,255,255,0.45);
     .left-box{
       .title{
         color: #9D9D9F;
       }
       .select{
         color: #FFFFFF;
       }
     }
   }
  .derivative-know-box{
    border: 2px dashed rgba(255,255,255,.3);
    .check-dom{
      .dom-title{
        color: #FFFFFF;
      }
    }
    .email-box{
      border: 1px solid rgba(255,255,255,0.45);
    }
    /deep/ .van-checkbox__label{
      font-size: 28px;
      color: #FFFFFF !important;
      font-weight: 400;
    }
    /deep/ .van-radio__label{
      font-size: 28px;
      color: #FFFFFF !important;
      font-weight: 400;
    }
    ::v-deep .upload-dom{
      .van-uploader__preview-delete{
        background-color: #8C8D8E;
      }
    }
  }
  .tip-box{
    border: 0.02667rem dashed rgba(255, 255, 255, 0.3);
  }
  .upload-dom{
    .upload-title{
      color: #FFFFFF !important;
    }
  }

  .upload-content{
    border: 2px dashed rgba(255,255,255,0.45);
  }
  /deep/ .van-uploader__preview{
    .van-uploader__preview-image{
      border: 2px dashed rgba(255,255,255,0.45);
    }
  }

  .tip{
    .tip-title{
      color: #FFFFFF !important;
    }
    .tip-content{
      color: #FFFFFF !important;
    }
  }
  .ipt-box{
    &.focus{
      .ipt-main{
        &:after{
          border-color: rgba(255,255,255,1);
        }
      }
    }
    &.error{
      .ipt-main{
        &:after{
          border-color: #fd2626;
        }
      }
    }
    .ipt-main{
      &:after{
        border-color: rgba(255,255,255,0.25);
      }
      .val-box{
        .label{
          color: #9D9D9F;
        }
      }
      .label{
        color: #9D9D9F;
      }
      .icon-arrow{
        background: url("../../../assets/images/open-account/dark_icon.png") no-repeat;
        width: 32px;
        height: 32px;
        background-size: 100% 100%;
      }
      .val{
        color: #fff !important;
        ::v-deep{
          .van-cell__value input::placeholder {
            color: #9D9D9F !important;
          }
          textarea{
            color: #fff;
          }
        }
      }
    }
  }
}
.error-tip{
  font-size: 24px;
  color: #FD2626;
  margin-top: 8px;
  margin-left: 32px;
}
// icon
.img-icon{
  width: 28px;
  height: 28px;
}
.ipt-box {
  margin-bottom: 24px;
  margin-top: 22px;
  &.focus{
    border-color: #17161C;
    .ipt-main{
      &:after{
        border-color: #17161C;
      }
      ::v-deep .van-cell{
        input {
          &::placeholder {
            font-size: 0;
          }
        }
      }
    }
  }
  &.error{
    .ipt-main {
      &:after {
        border-color: #FD2626;
      }
    }
  }
  .ipt-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 32px;
    min-height: 56px;
    position: relative;
    &:after{
      content: '';
      position: absolute;
      margin-top: -1px;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      border: 1px solid rgba(23, 22, 28, 0.25);
      transform: scale(0.5);
      border-radius: 20px;
    }
    .val-box {
      position: relative;
      flex: 1;
      display: flex;
      z-index: 1;
      flex-direction: column;
      line-height: 1;
      font-size: 32px;
      @keyframes labelAni{
        0%{
          font-size: 28px;
        }
        100%{
          font-size: 24px;
        }
      }
      .label {
        color: #747377;
        padding: 4px 0 20px;
        font-size: 24px;
        transform: translate3d(0,0,0);
            //animation: labelAni .2s .1s ease both;
        &.placeholder {
          padding: 12px 0 6px 0;
          font-size: 28px;
          animation: none;
        }
      }
      ::v-deep .van-cell {
        min-height: 0px;
        font-size: 32px;
        line-height: 32px;
        input{
          &::placeholder {
            font-size: 28px;
            color: #747377;
            font-weight: normal;
          }
          &:focus ~ .van-field__body{
            background: red;
          }
        }
        textarea {
          font-size: 32px;
          line-height: 35px;
          min-height: 70px;
          color: #17161c;
        }
      }
      .val {
        padding: 0;
        line-height: 36px;
        color: #17161c;
        font-weight: 500;
      }
    }
    .icon-arrow {
      width: 32px;
      height: 32px;
      background: url("../../../assets/images/arrow-down.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .error {
    display: none;
    margin-top: 12px;
    color: #fd2626;
    font-size: 24px;
    &.show{
      display: block;
    }
    &.right{
      text-align: right;
    }
  }
  &.error{
    .ipt-main{
      border-color: #fd2626;
    }
    .error{
      display: block;
    }
  }
}
.header-box1{
  margin-left: 32px;
  margin-right: 32px;
}
.bottom-k{
  padding-bottom: 150px;
}
.lang10-tip{
  font-size: 28px;
  color: #fd2626;
  margin-top: 10px;
  margin-bottom: 20px;
}
.derivative-know-box{
  border: 2px dashed rgba(23,22,28,0.25);
  border-radius: 8px;
  margin-left: 32px;
  margin-right: 32px;
  margin-top: 20px;
  padding: 28px 20px;
  .konwtitle{
    color: #F24E1E;
    font-size: 24px;
    font-weight: 400;
  }
  .check-dom{
    margin-top: 12px;
    .dom-title{
      margin-left: 32px;
      margin-right: 32px;
      margin-top: 12px;
      font-weight: 500;
      color: #17161C;
      font-size: 32px;
      margin-bottom: 32px;
    }
    .dom-chek{
      margin-bottom: 32px;
      padding-left: 32px;
      width: 40%;
    }
    .dom-chek1{
      margin-bottom: 32px;
      padding-left: 32px;
    }
    /deep/ .van-checkbox__label{
      font-size: 28px;
      color: #17161C;
      font-weight: 400;
    }
    /deep/ .van-radio__label{
      font-size: 28px;
      color: #17161C;
      font-weight: 400;
    }
    /deep/ .van-radio{
      flex: 1;
    }

  }
  .upload-dom{
    margin-top: 24px;
    .upload-title{
      font-size: 36px;
      font-weight: 500;
      margin-left: 32px;
      color: #1B1C24;
    }
    .tip{
      margin-top: 24px;
      margin-left: 32px;
      margin-right: 32px;
      margin-bottom: 28px;
      .tip-title{
        font-size: 28px;
        font-weight: 500;
        color: #1B1C24;
      }
      .tip-content{
        font-size: 28px;
        font-weight: 400;
        text-align: left;
        color: #747377;
        line-height: 48px;
      }
    }
    /deep/ .van-uploader__preview-delete{
      border-radius: 100%;
      width: 32px;
      height: 32px;
      left: 92%;
      background-color: #1B1C24;

    }
    /deep/ .van-uploader__preview-delete-icon{
      top: 0;
      right: 0;
    }
    /deep/ .van-uploader__preview{
      margin: 0px;
    }
  }
}
.tip-box{
  border: 2px dashed rgba(23,22,28,0.45);
  border-radius: 8px;
  margin-left: 32px;
  margin-right: 32px;
  margin-top: 20px;
  padding: 24px;
}
.bottom-box{
  height: 200px;
}

</style>
